import { defineComponent as _defineComponent } from 'vue'
import { computed, watch, onMounted } from 'vue'
    import { useId, useRoute } from '@common/composables'
    import { useIndividualReportPage } from '@RankHR/Regions/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'IndividualReportPage',
  setup(__props) {

    document.title = "Individual Report"

    const id = useId()
    const votingCycle = useRoute().params.votingCycle

    const { useIndividualReportQuery } = useIndividualReportPage()
    const { modelIndividualReportQueryV1, runIndividualReportQueryV1, authorized, redirectUrl } = useIndividualReportQuery(id, votingCycle)

    const model = computed(() => modelIndividualReportQueryV1.value)
    const personName = computed(() => modelIndividualReportQueryV1.value?.PersonName)
    const ranking = computed(() => modelIndividualReportQueryV1.value?.Ranking)
    const score = computed(() => modelIndividualReportQueryV1.value?.Score)
    const totalPossibleScore = computed(() => modelIndividualReportQueryV1.value?.TotalPossibleScore)
    const boardHighScore = computed(() => modelIndividualReportQueryV1.value?.BoardHighScore)
    const boardAverage = computed(() => modelIndividualReportQueryV1.value?.BoardAverage)
    const ratingProfile = computed(() => modelIndividualReportQueryV1.value?.RatingProfile)
    const boardRanking = computed(() => modelIndividualReportQueryV1.value?.BoardRanking)
    const ratingOverTime = computed(() => modelIndividualReportQueryV1.value?.RatingOverTime)
    const overallBoardScoringStatistics = computed(() => modelIndividualReportQueryV1.value?.OverallBoardScoringStatistics)
    const criteriaVotes = computed(() => modelIndividualReportQueryV1.value?.CriteriaVotes || [])
    const error = computed(() => modelIndividualReportQueryV1.value?.Error)

    onMounted(() => {
        runIndividualReportQueryV1()
    })

    watch(authorized, () => {
        if (!authorized.value) {
            location.href = redirectUrl.value
        }
    })

    watch(personName, () => document.title = `Report: ${personName.value}`)

return { __sfc: true,id, votingCycle, useIndividualReportQuery, modelIndividualReportQueryV1, runIndividualReportQueryV1, authorized, redirectUrl, model, personName, ranking, score, totalPossibleScore, boardHighScore, boardAverage, ratingProfile, boardRanking, ratingOverTime, overallBoardScoringStatistics, criteriaVotes, error }
}

})